import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

import type Camera from './Camera';
import type Renderer from './Renderer';

export default class Controls extends OrbitControls {
    static instance?: Controls;
    constructor(camera: Camera, renderer: Renderer) {
        super(camera, renderer.domElement);
    }

    static getInstance(camera: Camera, renderer: Renderer) {
        if (!Controls.instance) Controls.instance = new this(camera, renderer);
        return Controls.instance;
    }

    destroy() {
        this.dispose();
        delete Controls.instance;
    }
}
